import {NOTIFICATION_VISITED, GET_COMMUNICATION_LISTING } from '../../../Types'

const initialState = {
    newmsg: null
  }

const VLCCommunicationListingReducer = (state = initialState, action) => {
  switch (action.type) {
     case NOTIFICATION_VISITED:
      return { ...state, newmsg: action?.payload }
    case GET_COMMUNICATION_LISTING:
      return action.payload
    default:
      return state
  }
  
}
export default VLCCommunicationListingReducer